import * as React from "react";
import { Col } from "reactstrap";
import { ResponsiveContainer, Tooltip, CartesianGrid, XAxis, YAxis, AreaChart, Area } from "recharts";
import { CustomTooltipGASessions } from "src/share/components/CustomTooltip/CustomTooltip";
import { IPageViewsResult } from "./hooks/useGAPageViews";

export interface IGAPageViewsProps {
  pagePath?: string;
  daysAgo: number;
  pageViews: IPageViewsResult[];
}

export const GAPageViews = ({ pagePath, daysAgo, pageViews }: IGAPageViewsProps) => (
  <Col className="col-12 white-background">
    <h5>{pagePath && daysAgo ? daysAgo === 0 ? 'Opened today' : `Opened ${daysAgo} day${daysAgo > 1 ? 's' : ''} ago` : `Last ${daysAgo} days`}</h5>
    <h6 className="subtitle">Google page views</h6>
    <ResponsiveContainer width={'95%'} height={310}>
      <AreaChart height={310} data={pageViews}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip content={<CustomTooltipGASessions />} />
        {pageViews.length > 0 && <Area type='monotone' dataKey='count' stroke='#2ABCCA' fill='#2ABCCA' />}
        {pageViews.length === 0 && <Area type='monotone' dataKey='No Data to Show' stroke='grey' fill='grey' />}
        <h6>No data to show</h6>
      </AreaChart>
    </ResponsiveContainer>
  </Col>
)



// WEBPACK FOOTER //
// ./src/share/components/GoogleAnalitycs/GAPageViews.tsx